var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.isBusy,
          expression: "isBusy",
        },
      ],
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "element-loading-spinner": "el-icon-loading",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { prop: "note" } },
            [
              _c("el-input", {
                staticClass: "el-textarea-word-break-normal",
                attrs: {
                  type: "textarea",
                  rows: 5,
                  placeholder: "Add a note ...",
                },
                model: {
                  value: _vm.form.note,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "note", $$v)
                  },
                  expression: "form.note",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.canSetReadOnlyNote
            ? _c(
                "el-form-item",
                { attrs: { prop: "read_only", label: "Read only" } },
                [
                  _c("el-switch", {
                    model: {
                      value: _vm.form.read_only,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "read_only", $$v)
                      },
                      expression: "form.read_only",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-purple btn-sm px-4",
          attrs: { disabled: !_vm.canStore },
          on: { click: _vm.store },
        },
        [_vm._v("Store")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-secondary btn-sm px-4",
          on: { click: _vm.cancel },
        },
        [_vm._v("Cancel")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }